import { render, staticRenderFns } from "./profiili.vue?vue&type=template&id=64187d6b&scoped=true&"
import script from "./profiili.vue?vue&type=script&lang=ts&"
export * from "./profiili.vue?vue&type=script&lang=ts&"
import style0 from "./profiili.vue?vue&type=style&index=0&id=64187d6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64187d6b",
  null
  
)

export default component.exports